<template>
    <div class="vp-nav-container overflow-hidden">
        <div class="main_monitor"></div>
        <div class="blob"></div>
        <div class="vp-nav-hero">
            <div class="hero_texts">
                <Animation animationName="animate__fadeInUp">
                    <div class="vp-nav-text">Portál elektronických nákupov</div>
                </Animation>
                <Animation
                    animationName="animate__fadeInUp"
                    delay="0.3s"
                >
                    <div class="vp-nav-text1">Váš nástroj na zabezpečenie efektívnych elektronických nákupov a obstarávaní</div>
                </Animation>
            </div>
            <LoginPanel :mr="true" />
        </div>
    </div>
</template>

<script>
import Animation from '@/components/animation.vue';
import LoginPanel from '@/components/loginPanel.vue';

export default {
    name: 'VpHero',
    props: {
        loggedUser: null,
    },
    components: {
        Animation,
        LoginPanel,
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.hero {
    left: 0;
    right: 0;
    width: 50%;
    bottom: 0;
    position: absolute;
}
.righ-hero {
    position: absolute;
}

.hero_texts {
    width: 60%;
    display: flex;
    position: relative;
    align-self: center;
    align-items: flex-start;
    flex-direction: column;
}

.vp-nav-container {
    flex: 0 0 auto;
    width: 100%;
    min-height: 100%;
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
}

.main_monitor {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    background-size: cover;
    background-image: url('@/assets/main-1500h.jpg');
    background-repeat: no-repeat;
    background-position: left center;
}

.blob {
    top: 0px;
    right: 0px;
    width: 50%;
    bottom: 0px;
    position: absolute;
    background-size: 100%;
    background-image: url('@/assets/blob_elena-1500h.png');
    background-repeat: no-repeat;
    background-position: left center;

    @media (max-width: $breakpoint-lg-max) {
        background-size: 120%;
    }
}
.vp-nav-hero {
    flex: 0 0 auto;
    width: 100%;
    margin: auto;
    display: flex;
    position: relative;
    max-width: var(--dl-size-size-maxwidth);
    align-items: center;
    padding: 48px;
    flex-direction: row;
    justify-content: space-between;
}
.vp-nav-text {
    color: #052868;
    font-size: 120px;
    font-weight: 600;
    margin-bottom: var(--dl-space-space-oneandhalfunits);
    text-transform: uppercase;
    line-height: 1.2;
    @include transition(font-size);
}
.vp-nav-text1 {
    color: #000000;
    font-size: 1.5em;

    @media (max-width: $breakpoint-md-max) {
        // font-size: 24px;
    }
}

@media (max-width: 1920px) {
    .vp-nav-text {
        font-size: calc(6.3vw);
    }
}
@media (max-width: 1200px) {
    .main-monitor {
        height: 100%;
    }
    .blob {
        display: none;
    }
    .vp-nav-hero {
        flex-direction: column;

        .hero_texts {
            width: 100%;
            align-items: center;
            margin-bottom: 5rem;
            .vp-nav-text {
                text-align: center;
                font-size: calc(10vw);
            }
            .vp-nav-text1 {
                text-align: center;
            }
        }
    }
}

@media (max-width: 1200px) and (max-height: 1130px) {
    .vp-nav-container {
        .vp-nav-hero {
            padding: 48px;
        }
    }
}

@media (max-height: 660px) {
    .vp-nav-container {
        .vp-nav-hero {
            padding: 48px;
        }
    }
}

@media (max-width: $breakpoint-sm-max) {
    .vp-nav-hero {
        .hero_texts {
            margin-bottom: 3rem;
        }
    }
}

@media (max-width: $breakpoint-xs-max) {
    .vp-nav-hero {
        padding: 48px 15px !important;
        .vp-nav-text1 {
            font-size: 18px;
        }
    }
}
</style>
